import {
  ALIS_OWNER_ROLES_CODE_A1,
  ALIS_OWNER_ROLES_CODE_A2,
  ALIS_OWNER_ROLES_CODE_F1,
  ALIS_OWNER_ROLES_CODE_F2,
  ALIS_OWNER_ROLES_CODE_G1,
  ALIS_OWNER_ROLES_CODE_G2,
  ALIS_OWNER_ROLES_CODE_SPESIELL_BETALER_41,
  SYSTEM_NAME_ALIS,
} from '../insurance.constants';
import { InsuranceOverviewDto } from '../types/insurance.dto.types';
import {
  CorporateInsuranceOverview,
  InsuranceOverview,
  PrivateInsuranceOverview,
} from '../types/insurance.types';

const rolesAllowedToViewCost = [
  ALIS_OWNER_ROLES_CODE_A1,
  ALIS_OWNER_ROLES_CODE_A2,
  ALIS_OWNER_ROLES_CODE_G1,
  ALIS_OWNER_ROLES_CODE_G2,
  ALIS_OWNER_ROLES_CODE_F1,
  ALIS_OWNER_ROLES_CODE_F2,
  ALIS_OWNER_ROLES_CODE_SPESIELL_BETALER_41,
];

export const rolesAllowedToDownloadPolicyAndViewDetails = [
  ALIS_OWNER_ROLES_CODE_A1,
  ALIS_OWNER_ROLES_CODE_A2,
  ALIS_OWNER_ROLES_CODE_G1,
  ALIS_OWNER_ROLES_CODE_G2,
  ALIS_OWNER_ROLES_CODE_F1,
  ALIS_OWNER_ROLES_CODE_F2,
];

export function hasCostViewPermission(dto: InsuranceOverviewDto): boolean {
  return hasPermission(dto, rolesAllowedToViewCost);
}

export function hasPolicyDownloadPermission(
  dto: InsuranceOverviewDto,
): boolean {
  return hasPermission(dto, rolesAllowedToDownloadPolicyAndViewDetails);
}

export function isAlis(systemName: string): boolean {
  return systemName === SYSTEM_NAME_ALIS;
}

function hasPermission(
  dto: InsuranceOverviewDto,
  allowedRoles: string[],
): boolean {
  if (!isAlis(dto.product.systemName)) {
    return true;
  }

  if (!dto.alisCustomerRolesOnPolicy) {
    return false;
  }

  return dto.alisCustomerRolesOnPolicy.some((customerRole) =>
    allowedRoles.includes(customerRole),
  );
}

export function isCorporatePayedInsuranceOverview(
  overview: InsuranceOverview,
): overview is CorporateInsuranceOverview {
  const { systemName, type } = overview;
  if (
    systemName &&
    (systemName === 'USB' || systemName === 'CMS' || systemName === 'ABA')
  ) {
    return ['SURVIVOR', 'DISABILITY', 'HEALTH'].includes(type.toUpperCase());
  }

  return false;
}

export function isPrivateInsuranceOverview(
  overview: InsuranceOverview,
): overview is PrivateInsuranceOverview {
  return !isCorporatePayedInsuranceOverview(overview);
}
